export default __webpack_public_path__ + "static/media/049-thermometer.efb9fdee.svg";